import { render, staticRenderFns } from "./RsaGestioneOspitiListComponent.vue?vue&type=template&id=497db86a"
import script from "./RsaGestioneOspitiListComponent.vue?vue&type=script&lang=js"
export * from "./RsaGestioneOspitiListComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaGestioneOspitiListComponent.vue?vue&type=style&index=0&id=497db86a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports